import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App';
import { UiPolish } from './ui/UiPolish';
import './styles.css';
import './admin.css';
import './desktop-fixes.css';
import './planner-polish.css';
import './ui-polish.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    mutations: { retry: 0 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}><UiPolish /><App /></QueryClientProvider>
  </React.StrictMode>,
);
